import React from "react";
import "tachyons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProgressBar.css";


function ProgressBar(props) {
    return (

        
            <div className="col-sm-12">
                <h3 className="f3 fw4 ttu">{props.name}</h3>
                <div className="progress bg-secondary">
                    <div className="progress-bar bg-dark" role="progressbar" style={{ width: props.value }} aria-valuenow={props.value} aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
    )
}

export default ProgressBar;